module.exports = __webpack_public_path__ + "static/img/11.84d836e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/11.png
// module id = S+OI
// module chunks = 0